import {
    GenericTableColumn,
    GenericTableColumnType,
    GenericTableNumberFormat,
} from '../../../../../../../../api/generic-tables/dto';
import { FormattedMessage } from 'react-intl';
import { IconButton, Stack } from '@mui/material';
import { SettingOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { FormatSettingsDialog } from './format-settings-dialog';
import { NUMBER_FORMAT_TO_TRANSLATION_KEY } from './consts';

type FormattingCellProps = {
    column: GenericTableColumn;
    onChange: (newColumn: GenericTableColumn) => void;
    languages: string[];
};

export const FormattingCell = ({ column, languages, onChange }: FormattingCellProps) => {
    const [editMode, setEditMode] = useState(false);
    return (
        <Stack direction="row" gap={1} alignItems="center">
            <FormattingSummary column={column} />
            <IconButton size="small" onClick={() => setEditMode(true)}>
                <SettingOutlined />
            </IconButton>
            <FormatSettingsDialog
                open={editMode}
                column={column}
                languages={languages}
                onSave={(newColumn) => {
                    onChange(newColumn);
                    setEditMode(false);
                }}
                onCancel={() => {
                    setEditMode(false);
                }}
            />
        </Stack>
    );
};

const FormattingSummary = ({ column }: Pick<FormattingCellProps, 'column'>) => {
    switch (column.type) {
        case GenericTableColumnType.Text:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.text" />;

        case GenericTableColumnType.Boolean:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.boolean" />;

        case GenericTableColumnType.Number:
            return (
                <FormattedMessage
                    id="inside-fifa.generic-tables.column-format.number-summary"
                    values={{
                        format: (
                            <FormattedMessage
                                id={
                                    NUMBER_FORMAT_TO_TRANSLATION_KEY[column.numberFormat] ??
                                    NUMBER_FORMAT_TO_TRANSLATION_KEY[GenericTableNumberFormat.Unknown]
                                }
                            />
                        ),
                    }}
                />
            );

        case GenericTableColumnType.Date:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.date" />;

        case GenericTableColumnType.Email:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.email" />;

        case GenericTableColumnType.Url:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.url" />;

        case GenericTableColumnType.BynderId:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.bynder-id" />;

        case GenericTableColumnType.FdcpConfederation:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.fdcp-confederation" />;
        case GenericTableColumnType.FdcpAssociation:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.fdcp-association" />;

        case GenericTableColumnType.Image:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.image" />;

        case GenericTableColumnType.Unknown:
            return <FormattedMessage id="inside-fifa.generic-tables.column-format.unknown" />;
    }
};
